import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";
import { AnsweredQuestionWithId } from "@teamprevent/common/questionnaires/model";

import { SUBMIT_QUESTIONNAIRE, submitQuestionnaireSuccess, questionnaireLoaded } from "@teamprevent/common/questionnaires/actions";

import axios from "axios";
import { toast } from "@teamprevent/common/toasts";
import { Payload } from "@neworbit/redux-helpers";

import { TasksUpdatedSuccessResult } from "../task/model";
import { ClinicalNotesApi } from "../clinicalNotes/ClinicalNotesApi";
import { FollowUpTaskModel } from "../immunisationReview/model";

import * as actions from "./actionTypes";

export type SubmitBloodTestConsultationSuccess = ({ type: typeof actions.SUBMIT_BLOOD_TEST_CONSULTATION_SUCCESS }) & Payload<TasksUpdatedSuccessResult>;

export type BloodTestAction = SubmitBloodTestConsultationSuccess;

export const buildSubmitImmunisationBloodTestConsultation = (clinicalNotesApi: ClinicalNotesApi) => {
    return (
        ohCaseId: string,
        taskId: string,
        customerId: string,
        questions: AnsweredQuestionWithId[],
        questionnaireKey: string,
        tasks: FollowUpTaskModel[],
        immunisationTypeTaskIds: string[]) => {
        return async (dispatch: Dispatch) => {
            const result = await loadAndTrack(
                dispatch,
                SUBMIT_QUESTIONNAIRE,
                clinicalNotesApi.submitImmunisationBloodTestConsultation(ohCaseId, taskId, questions, tasks, immunisationTypeTaskIds));
            toast.success("Blood test consultation submitted successfully");
            dispatch(submitQuestionnaireSuccess(questionnaireKey));
            dispatch(submitBloodTestConsultationSuccess({
                ohCaseId,
                tasks: result
            }));
        };
    };
};

export const submitImmunisationBloodTestConsultation = buildSubmitImmunisationBloodTestConsultation(new ClinicalNotesApi(axios));

export const buildLoadBloodTestConsultation = (clinicalNotesApi: ClinicalNotesApi) => {
    return (ohCaseId: string, taskId: string, questionnaireKey: string) => {
        return async (dispatch: Dispatch) => {
            const response = await loadAndTrack(dispatch, "loadQuestionnaire", clinicalNotesApi.load(ohCaseId, taskId));
            if (response && response.data.questions) {
                dispatch(questionnaireLoaded({ questions: response.data.questions, questionnaireKey }));
            }
        };
    };
};

export const loadClinicalNotes = buildLoadBloodTestConsultation(new ClinicalNotesApi(axios));

export const submitBloodTestConsultationSuccess = (payload: TasksUpdatedSuccessResult): SubmitBloodTestConsultationSuccess => {
    return {
        type: actions.SUBMIT_BLOOD_TEST_CONSULTATION_SUCCESS,
        payload
    };
};
